<template>
  <el-dialog
    class="modify-order-platform"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    custom-class="greater"
  >
    <div class="content" v-loading="isLoading">
      <el-form
        ref="form"
        :rules="rules"
        label-position="right"
        :model="formData"
        class="horseman-platform__form"
        @submit.native.prevent
      >
        <el-form-item label="所属品牌:" prop="brandName">
          <el-input disabled v-model="formData.brandName" style="width: 440px;"></el-input>
          <el-button @click="$_selectBrand" class="select__btn" >选择</el-button>
          <span v-show="formType !== 'edit'" class="input-tips">非必选，未选时默认为“公共”</span>
        </el-form-item>

        <el-form-item label="标题:" prop="title">
          <el-input v-model.trim="formData.title" placeholder="必填" class="form-item__input" style="width: 440px;"></el-input>
          <span class="input-tips">*输入中文，字母或数字，最多100字</span>
        </el-form-item>

        <el-form-item label="里程碑时间:" prop="time">
          <el-date-picker
            v-model="formData.time"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:291px;"
            placeholder="选择日期"
          ></el-date-picker>
          <span class="input-tips">*时间格式为yyyy-mm-dd</span>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>
    <!-- 选择品牌弹窗组件 -->
    <select-brand
      v-if="modal.show === true && modal.template === 'select-brand'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_callbackBrand"
      @close="$_close"
    ></select-brand>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectBrand from "./modal-select-brand";

export default {
  name: "modal-modify",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        brandId: 0,
        brandName: "公共",
        title: "",
        time: ""
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      rules: {
        title: [{ required: true, message: "请输入标题!", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (Utils.getStrLength(value) > 100) {
                callback(new Error("最多100个字!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },],
        time: [
          { required: true, message: "请选择里程碑时间!", trigger: "blur" }
        ]
      }
    };
  },

  methods: {
    // 选择品牌
    $_selectBrand() {
      this.modal.data = {
        brandName: this.formData.brandName,
        brandId: this.formData.brandId
      };
      this.modal.title = "选择品牌";
      this.modal.template = "select-brand";
      this.modal.show = true;
    },
    // 选择品牌回调
    $_callbackBrand(data) {
      let { brandName, brandId } = data;
      this.formData.brandName = brandName;
      this.formData.brandId = brandId;
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
    // 保存
    $_submit() {
      const self = this;
      this.$refs["form"].validate(valid => {
        if (valid) {
          let action = "milestonesave";
          let { brandId, title, time } = this.formData;
          let postData = {
            brandId,
            title,
            time
          };

          if (this.formType === "edit") {
            action = "milestonemodify";
            Object.assign(postData, { mid: this.formData.mid });
          }
          self.isLoading = true;
          self.$service.post(action, postData).then(result => {
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.$emit("callback");
                  self.visible = false;
                }
              });
            } else {
              self.isLoading = false;
            }
          });
        }
      });
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  components: {
    SelectBrand
  },
  created() {
    if (this.formType === "edit" && Object.keys(this.modalData).length > 0) {
      let { brandId, title, time, mid,brandName } = this.modalData;
      this.formData.brandName=brandName;
      this.formData.mid = mid;
      this.formData.brandId = brandId;
      this.formData.title = title;
      this.formData.time = time;
    }
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: {
    left: 30px;
    top: 20px;
  }
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
  .horseman-platform__form {
    .form-item__input {
      width: 291px;
      height: 28px;
    }
  }
}
.key-item {
  margin: {
    bottom: 10px;
  }
}
.key__input {
  width: 120px;
  margin: {
    right: 10px;
  }
}
.delete-key__btn,
.add-key__btn {
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  background: none;
  border: 0;
  margin: 0;
  color: #68768a;
}
.delete-key__btn {
  .cd-icon__delete {
    width: 10px;
    height: 10px;
    background: url(~@/assets/images/icon-delete.png) no-repeat center;
    &:hover,
    &:focus {
      background: url(~@/assets/images/icon-delete__hover.png) no-repeat center;
    }
  }
  + .add-key__btn {
    margin: {
      left: 0;
    }
  }
}
.key__radio {
  + .add-key__btn {
    margin: {
      left: 10px;
    }
  }
}
.add-key__btn {
  .cd-icon__add {
    width: 10px;
    height: 10px;
    margin-right: 5px;
    background: url(~@/assets/images/icon-add.png) no-repeat center;
  }
  &:hover,
  &:focus {
    border-radius: 4px;
    background-color: #68768a;
    color: #fff;
    .cd-icon__add {
      background: url(~@/assets/images/icon-add__hover.png) no-repeat center;
    }
  }
}
.input-tips {
  margin-left: 10px;
}
.select__btn {
  margin-left: 8px;
  vertical-align: top;
}

</style>
